var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.chart.chartOptions,"series":_vm.chart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }